import { RouteConfig } from "vue-router";

export const RCompaniesBrowse: RouteConfig = {
  name: "CompaniesBrowse",
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "guide-browse" */
      "./VCompaniesBrowse.vue"
    ),
  meta: {
    title: "Companies",
  },
};
